import React from 'react'
import NotePadApplication from '../components/notepad';
import { AppPage } from '../layouts/types';

const Notepad:AppPage = () => {

    return ( <div className="h-screen w-screen">
        <NotePadApplication />
    </div> )
}

export default Notepad;